import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function Problem() {
  const problems = ['Llegás a fin de mes sin saber a dónde fue tu plata', 'Tu plata parada pierde valor contra la inflación todos los días', 'El miedo te paraliza antes de hacer tu primera inversión', 'Gastos hormiga que ni siquiera notás', 'Te bloqueás frente a CEDEARs, FCI o plazo fijo UVA', 'Empezás a ahorrar, lo dejás, volvés a empezar'];
  return <section className="bg-light text-navy py-16 px-4" data-id="element-179">
      <div className="max-w-[720px] mx-auto" data-id="element-180">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-4 leading-tight" data-id="element-181">
          ¿Cuántos meses más vas a dejar tu plata quieta?
        </h2>
        <p className="text-center text-[16px] text-navy/70 mb-10 font-medium" data-id="element-182">
          Sin un sistema claro, siempre terminás igual.
        </p>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-navy/5 mb-8" data-id="element-183">
          <ul className="space-y-4" data-id="element-184">
            {problems.map((problem, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-3 text-[15px] text-navy/80 leading-[1.6]" data-id="element-185">
                <X className="text-red-500 flex-shrink-0 mt-0.5" size={20} data-id="element-186" />
                <span data-id="element-187">{problem}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-emerald text-white p-6 rounded-2xl text-center shadow-lg" data-id="element-188">
          <p className="text-[16px] font-medium leading-[1.6]" data-id="element-189">
            <span className="font-bold block mb-1" data-id="element-190">
              No es falta de ingresos. Es falta de un sistema.
            </span>
            Con El Costo de No Hacer Nada, el próximo mes puede ser diferente.
            💰
          </p>
        </motion.div>
      </div>
    </section>;
}